import { Component } from '@angular/core';
import { IconComponent } from '@vg-constellation/angular-20/icon';
import { LinkModule } from '@vg-constellation/angular-20/link';
import { ContentUtil } from '../../../utils/content/content.util';
import { content } from '../../../../content/zci/content';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'zci-access-denied',
    standalone: true,
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
    imports: [IconComponent, LinkModule],
})
export class AccessDeniedComponent {
    readonly content = ContentUtil.content || content;
    readonly environment = environment;
    readonly hintParts = this.content.accessDenied.sailPointHint?.split(';') || [];
}
